import { render, staticRenderFns } from "./ExtractFloorsDialog.vue?vue&type=template&id=704b1ad2&lang=pug&"
import script from "./ExtractFloorsDialog.vue?vue&type=script&lang=js&"
export * from "./ExtractFloorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports